import { SVGProps } from "react";

export default function EmailShareIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#333333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.66406 7.08366C1.66406 4.16699 3.33073 2.91699 5.83073 2.91699H11.6641"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3307 8.75V12.9167C18.3307 15.8333 16.6641 17.0833 14.1641 17.0833H5.83073C3.33073 17.0833 1.66406 15.8333 1.66406 12.9167V10.8167"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83594 7.5L8.44428 9.58333C9.30261 10.2667 10.7109 10.2667 11.5693 9.58333L12.5526 8.8"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2474 6.66667C17.398 6.66667 18.3307 5.73393 18.3307 4.58333C18.3307 3.43274 17.398 2.5 16.2474 2.5C15.0968 2.5 14.1641 3.43274 14.1641 4.58333C14.1641 5.73393 15.0968 6.66667 16.2474 6.66667Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
